import React,{useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import heroImg from "../img/page-bg.jpg";
import divider from "../img/divider.png";
import {NftGallery} from 'react-nft-gallery';


const bgStyle = {
  width: '100vw',
  height: '100vh',
  objectFit:'cover',
  position: 'fixed',
  left:'0'
};
const contentStyle = {
  position: 'relative',
  padding:'80px 0'
};


const Gallery = () => {
  
  return (
    <div className="container">
      <img style={bgStyle} src={heroImg} alt="heroImg" />
    	<div style={contentStyle} className="content-wrapper">
        <h1 className="pageHeader">EXPLORE
        <img className="pageHeaderDivider" src={divider} alt="divider" /></h1>
        <NftGallery ownerAddress="0xd18a67f82bf9289cfa8067852026c1f93126f502" />
      </div>
    </div>
  );
};

export default Gallery;
